import axios from "../../utils/axios";
import { API_SUFFIX } from "../../config/app";

// 获取治理总量查询
export function apiGovernanceTotal(query) {
    return axios({
        url: "/admin/index/governance_total" + API_SUFFIX,
        method: "get",
        params: query
    });
}
// 修改
export function apiGovernanceTotalSubmit(data, method = "post") {
    return axios({
        url: "/admin/index/governance_total" + API_SUFFIX,
        method: method,
        data: data
    });
}